import { useEffect, useState } from 'react';
import { IFinancingOffersModificationUser } from '../../interfaces/financingOfferModificationUser';
import { arsInfoManagementApi } from '../../service/arsInfoManagementApi';
import { useAxios } from './useAxios';
import { useLoader } from './useLoader';

export const useFinancingOffers = () => {
  const [response, error, loading, axiosFetch] = useAxios();
  const [financing, setFinancing] = useState<
    IFinancingOffersModificationUser[]
  >([]);
  const { setLoader } = useLoader();

  const getFinancing = async (branchId: number) => {
    return await axiosFetch({
      axiosInstance: arsInfoManagementApi,
      method: 'get',
      url: 'FinancingOffer',
      requestConfig: {
        params: { branchId },
      },
    });
  };

  useEffect(() => {
    if (response?.recordset) {
      setFinancing(response?.recordset);
    }
  }, [response]);

  useEffect(() => {
    setLoader(loading);
    return () => {
      setLoader(false);
    };
  }, [loading]);

  return { financing, loading, getFinancing };
};
